import { initializeApollo } from "src/gql/createApolloClient";

const apolloClients = new Map<
  string | null,
  ReturnType<typeof initializeApollo>
>();

export const useApollo = (workspaceId: string | null) => {
  let apolloClient = apolloClients.get(workspaceId);
  if (apolloClient == null) {
    apolloClient = initializeApollo(workspaceId);
    apolloClients.set(workspaceId, apolloClient);
  }

  return apolloClient;
};
